// extracted by mini-css-extract-plugin
export default {"productDetailHeader":"CategoryListCard_productDetailHeader__+-sOI","icons":"CategoryListCard_icons__mp6KE"};